/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { TimeManager as ITimeManager } from '../../time'
 */
/* eslint-env browser */

import ErrorName from '../../error/error-name';
import { errorWithName } from '../../error/error-with-name';

/**
 * @import { TimeManager } from '../../time'
 */

/**
 * Správce času a časových zón pro standardní webové technologie.
 * @implements {ITimeManager}
 */
export default class WebTimeManager {
  /** @type {ITimeManager['getNtp']} */
  async getNtp() {
    throw await errorWithName(
      ErrorName.NotSupportedError,
      'NTP not supported on web platform.'
    );
  }

  /** @type {TimeManager['getZone']} */
  async getZone() {
    try {
      return await Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      const error = /** @type {Error} */ (e);
      error.name = ErrorName.NotSupportedError;
      throw error;
    }
  }
}
